import {computed, Injector, Signal} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {DexComputedLpService} from '../../components/dex/dex-streaming/computed/dex-computed-lp.service';
import {DexComputedTrancheService} from '../../components/dex/dex-streaming/computed/dex-computed-tranche.service';
import {ComputedTranche} from '../../components/dex/dex-streaming/types/computed/computed-tranche';
import {
    WidgetImplementation,
    WidgetImplementationEvent,
    WidgetImplementationEventFlags
} from '../../components/layout/widget/widget-implementation';
import {
    getWidgetSettingsWithUpdatesStream,
    setWidgetSettings,
    updateWidgetSettings
} from '../components/common-widget.implementation';
import {DexLpCollapsedWidgetSettings} from './settings/dex-lp-collapsed-widget-settings';
import {DexLpCollapsedWidgetSettingsService} from './settings/dex-lp-collapsed-widget-settings.service';

export class DexLpCollapsedWidgetImpl implements WidgetImplementation {

    public settings: DexLpCollapsedWidgetSettings;

    public settingsService: DexLpCollapsedWidgetSettingsService = this.injector.get(DexLpCollapsedWidgetSettingsService);

    public ready$ = new BehaviorSubject<boolean>(false);

    public event$ = new Subject<WidgetImplementationEvent>();

    public settingsWithUpdates$: Observable<Partial<DexLpCollapsedWidgetSettings>> =
               getWidgetSettingsWithUpdatesStream(this);

    public readonly $lp = computed(() => this.dexComputedLpService.$list()[0]);
    public readonly $traches: Signal<ComputedTranche[]>;

    private readonly dexComputedLpService = this.injector.get(DexComputedLpService);
    private readonly dexComputedTrancheService = this.injector.get(DexComputedTrancheService);

    constructor(
        private injector: Injector
    ) {
        this.$traches = this.dexComputedTrancheService.$list;
    }

    public setSettings(
        settings?: DexLpCollapsedWidgetSettings,
        flags?: WidgetImplementationEventFlags
    ): Observable<DexLpCollapsedWidgetSettings> {
        return setWidgetSettings(this, settings, flags);
    }

    public updateSettings(
        updates?: Partial<DexLpCollapsedWidgetSettings>,
        flags?: WidgetImplementationEventFlags
    ): Observable<Partial<DexLpCollapsedWidgetSettings>> {
        return updateWidgetSettings(this, updates, flags);
    }

}
